// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import axios from './plugins/axios'
import MdsUi from '@bic-fe/mds-ui' // 引入组件
import '@bic-fe/mds-ui/dist/mds-ui.min.css' // 引入组件的样式
import { vuePlugin } from '@broker/detector-plugins'
// import * as utilBase from '@/utils/base'

Vue.use(axios)
Vue.use(MdsUi)

vuePlugin(window.ErrorDetector, Vue)
Vue.config.productionTip = false

/* global Beidou */
if (typeof Beidou !== 'undefined') {
  // const isDeveloper = !!utilBase.getCookie('developer') || false
  // Beidou.init({
  //   projectId: 62, // 必传 ，在58北斗监控平台添加项目时，生成的项目ID
  //   isProd: process.env.NODE_ENV === 'production' && !isDeveloper, //  非必传， 是否将捕获的异常信息发送到北斗服务器   为true时 发送上报请求 默认为true
  //   isDebug: false, // 非必传  是否打印日志 为true时 打印 默认为false
  // })

  // Vue.config.errorHandler = function (err, vm, info) {
  //   // 你可以在此处，手动调用 Beidou.captureException 将错误日志上报给北斗服务器
  //   Beidou.captureException(err, info)
  // }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js